/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Add_Another_SchoolInputs */

const nl_common_add_another_school = /** @type {(inputs: Common_Add_Another_SchoolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voeg een school toe`)
};

/**

* @param {Common_Add_Another_SchoolInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_add_another_school = /** @type {((inputs?: Common_Add_Another_SchoolInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Add_Another_SchoolInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_add_another_school(inputs)
});
export { common_add_another_school as "common.add_another_school" }